// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__m5loH","title":"Header_title__2FL2r","side":"Header_side__3bBfL"};